<ng-template [ngIf]="false">
  <div class="new-subject-banner">
    <div class="cover" [lazyLoad]="assetsUrl('/assets/images/subject_banner_cover.jpg')"></div>
    <div class="info">
    <span class="text normal">{{ 'new-subject-banner.text1' | customLocale }}
      <span
        class="text bold highlighted">{{ 'new-subject-banner.text2' | customLocale }}</span> {{ 'new-subject-banner.text3' | customLocale }}
      <span class="text bold highlighted"> {{ 'new-subject-banner.text4' | customLocale }}</span>
    </span>

      <div class="action-btn" (click)="newLesson()">{{ 'new-subject-banner.action' | customLocale }}</div>
    </div>
  </div>
</ng-template>

<ng-template [ngIf]="!deviceService.isDesktop()">
  <section class="new-subject-banner" [class.mobile]="deviceService.isMobile()">
    <div class="cover" [lazyLoad]="assetsUrl('/assets/images/subject_banner_cover_2.jpg')"></div>
    <div class="right-block">
      <h2 class="title bold">{{ 'ad.ad-create-content.title' | customLocale }}</h2>

      <div *ngFor="let thesis of thesisList; trackBy: trackByFn" class="thesis-wrap">
        <div class="icon-wrap">
          <app-icon width="18" height="15" icon="daw"></app-icon>
        </div>
        <span class="thesis-label normal">{{ thesis | customLocale }}</span>
      </div>

      <div class="actions">
        <a routerLink="/constructor" class="btn btn-secondary md lg">{{ 'ad.ad-create-content.action' | customLocale }}</a>
      </div>
    </div>
  </section>
</ng-template>
